import { chunk } from '@belong/common';
import { Carousel } from '@belong/ui';
import { PrismicDocument } from '@prismicio/types';
import clsx from 'clsx';
import { BlogCard } from 'src/features/blog/components/card/card';
import css from './blog-carousel.module.css';

type BlogCarouselProps = {
  blogPosts: PrismicDocument[];
  theme?: 'dark' | 'light';
  blurredEnds?: boolean;
};

export function BlogCarousel({
  blogPosts = [],
  theme,
  blurredEnds,
}: BlogCarouselProps) {
  return (
    <>
      {/* Mobile */}
      <div className="contents md:hidden">
        <_BlogCarousel
          blogPosts={blogPosts}
          cardsPerSlide={1}
          theme={theme}
          blurredEnds={blurredEnds}
        />
      </div>
      {/* Tablet */}
      <div className="hidden md:contents xl:hidden">
        <_BlogCarousel
          blogPosts={blogPosts}
          cardsPerSlide={2}
          theme={theme}
          blurredEnds={blurredEnds}
        />
      </div>
      {/* Tablet */}
      <div className="hidden xl:contents">
        <_BlogCarousel
          blogPosts={blogPosts}
          cardsPerSlide={3}
          theme={theme}
          blurredEnds={blurredEnds}
        />
      </div>
    </>
  );
}

type _BlogCarouselProps = {
  blogPosts: PrismicDocument[];
  cardsPerSlide: number;
  theme?: 'light' | 'dark';
  blurredEnds?: boolean;
};

function _BlogCarousel({
  blogPosts,
  cardsPerSlide,
  theme,
  blurredEnds,
}: _BlogCarouselProps) {
  return (
    <Carousel theme={theme} blurredEnds={blurredEnds}>
      {chunk(blogPosts, cardsPerSlide).map((posts, idx) => (
        <div
          className="mb-xs mr-lg md:mb-sm flex min-w-full justify-center last:mr-0"
          key={idx}
        >
          {posts.map((post, postIdx) => (
            <div
              className={clsx('mr-lg last:mr-0', css.cardContainer)}
              key={postIdx}
            >
              <BlogCard post={post} variant="carousel" theme={theme} />
            </div>
          ))}
        </div>
      ))}
    </Carousel>
  );
}
